<template>
  <!-- 删除 -->
  <div class="">
    <v-dialog
      class="del"
      name="dialog2"
      v-model="isShow"
      title="删除日志"
      close-on-click-modal
      :modal="true"
      :width="668"
      :height="274"
      @after-close="handleAfterClose"
      @confirm="handleConfirm"
      append-to-body
      confirmButtonText="删除"
    >
      确定删除此条日志吗？
    </v-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    showInputDialog: {
      type: Boolean,
      default: false,
    },
    row: {},
  },
  data() {
    return {
      isShow: false,
    };
  },
  created() {},
  watch: {
    showInputDialog(newVal) {
      this.isShow = newVal;
    },
  },
  methods: {
    handleConfirm() {
      this.$delete(`/td/td-iot-api/iot/upgrade/force/statistic/${this.row.strategy_id}`, {}).then((res) => {
        let code = +res.code;
        if (code === 0) {
          this.$emit("getData");
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
      this.$emit("update:showInputDialog", false);
    },
    handleAfterClose() {
      this.$emit("update:showInputDialog", false);
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss"></style>
